import React, { useEffect, useState } from 'react';
import { Shell, ConfigProvider, Icon, Box, Message } from '@fpxfd/next';
import PageNav from './components/PageNav';
import HeaderAvatar from './components/HeaderAvatar';
import Logo from './components/Logo';
import Lang from './components/Lang';
import TopMenu from './components/TopMenu';
import Warehouse from './components/Warehouse';
import { useLocalStorageState, useToggle } from 'ahooks';
import styles from './index.module.scss';
import store from '@/store';
import { useLocation, useHistory, request } from 'ice';
import { getLocale } from '@/locales/locale';
import { getWarehouseCode, transformWareHouse } from '@/utils';

(function () {
  const throttle = function (type: string, name: string, obj: Window = window) {
    let running = false;

    const func = () => {
      if (running) {
        return;
      }

      running = true;
      requestAnimationFrame(() => {
        obj.dispatchEvent(new CustomEvent(name));
        running = false;
      });
    };

    obj.addEventListener(type, func);
  };

  if (typeof window !== 'undefined') {
    throttle('resize', 'optimizedResize');
  }
})();

interface IGetDevice {
  (width: number): 'phone' | 'tablet' | 'desktop';
}
export default function BasicLayout({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const history = useHistory();
  const getDevice: IGetDevice = (width) => {
    const isPhone = typeof navigator !== 'undefined' && navigator && navigator.userAgent.match(/phone/gi);

    if (width < 680 || isPhone) {
      return 'phone';
    } else if (width < 1280 && width > 680) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  };

  const [device, setDevice] = useState(getDevice(NaN));

  const [triggerStatus, { toggle }] = useToggle();

  const [user, userDispatchers] = store.useModel('user');

  const [permission, permissionDispatchers] = store.useModel('permission');
  const [dict, dictDispatchers] = store.useModel('dict');
  const [users, setUsers] = useLocalStorageState<string>('user', '');

  if (typeof window !== 'undefined') {
    window.addEventListener('optimizedResize', (e) => {
      const deviceWidth = (e && e.target && (e.target as Window).innerWidth) || NaN;
      setDevice(getDevice(deviceWidth));
    });
  }

  const trigger = () => (
    <a>
      <Icon
        type={triggerStatus ? 'daohangzhankai' : 'daohangshouqi'}
        className={styles.Trigger}
        onClick={() => toggle()}
      />
    </a>
  );

  const dmasAiinit = () => {
    request({
      url: '/intelligent/ai/chatbot/config?code=giws',
      method: 'POST',
    }).then((res) => {
      console.log(res);
      if (res?.token && res?.scriptSrc) {
        const script = document.createElement('script');
        script.src = res.scriptSrc;
        script.id = res.token;
        script.defer = true;
        document.head.appendChild(script);
        window?.difyChatbotConfig = res;
      }
    });
  };

  useEffect(() => {
    permissionDispatchers.fetchMenuTreePermission(users.userId);
    permissionDispatchers.fetchMenuPermission(users.userId);
    userDispatchers.fetchWarehouse();
    dictDispatchers.fetchFBAChannel();
    dictDispatchers.fetchFBATruckChannel();
    dictDispatchers.fetchUrlConfigList();
    dictDispatchers.fetchAllWarehouseList();
    dictDispatchers.newWaveAnalyzeSwitchMapApi();
  }, [getLocale()]);

  useEffect(() => {
    // 路由守卫
    if (
      !pathname.includes('cone') &&
      pathname &&
      permission.menuArr?.length &&
      pathname !== '/' &&
      permission.usePermission
    ) {
      const flag = permission.menuArr.some((e) => {
        return e?.path === pathname || (pathname.startsWith(e?.path) && e?.isDetail);
      });
      !flag && history.push('/notFound');
    }
  }, [history, pathname, permission.menuArr, permission.usePermission]);

  useEffect(() => {
    const getWarehouse = () => {
      const str: string = window.localStorage.getItem('wareMenuList') || window.localStorage.getItem('wareMenu') || '';
      if (!str) return '';
      const wareHouseList: [] = JSON.parse(str);
      userDispatchers.update({
        warehouseName: transformWareHouse(getWarehouseCode()),
        warehouseList: wareHouseList,
      });
    };
    getWarehouse();
    dmasAiinit();
    window.addEventListener('setStorageItemEvent', getWarehouse);
    return () => {
      window.removeEventListener('setStorageItemEvent', getWarehouse);
    };
  }, []);

  const FullScreen = ['/service/outbound/billboard/detail', '/service/inbound/billboard/detail'];
  return FullScreen.filter((e) => e === pathname).length ? (
    children
  ) : (
    <ConfigProvider device={device}>
      <Shell
        style={{
          minHeight: '100vh',
        }}
      >
        <Shell.Branding style={{ height: '100%' }}>
          <Logo image="../../../public/logo.png" />
        </Shell.Branding>
        <Shell.Action style={{ flex: 1 }}>
          <Box direction="row" justify="space-between" flex={1} style={{ width: '100%' }}>
            <div id="TopMenuWrap" className={styles.TopMenu}>
              <TopMenu />
            </div>
            <Box id="InfoWrap" direction="row" align="center" justify="space-between">
              <Warehouse />
              <Lang />
              <HeaderAvatar />
            </Box>
          </Box>
        </Shell.Action>
        {pathname !== '/' && (
          <Shell.Navigation trigger={user.menu === 'index' ? null : trigger()}>
            <PageNav />
          </Shell.Navigation>
        )}
        {/* {
          !FullScreen.filter((e) => e === pathname).length &&
            <Shell.Branding style={{ height: '100%' }}>
              <Logo image="../../../public/logo.png" />
            </Shell.Branding>
        }
        {
          !FullScreen.filter((e) => e === pathname).length &&
          <Shell.Action style={{ flex: 1 }}>
            <Box direction="row" justify="space-between" flex={1}>
              <TopMenu />
              <Box direction="row" align="center" justify="space-between">
                <Warehouse />
                <Lang />
                <HeaderAvatar />
              </Box>
            </Box>
          </Shell.Action>
        }
        {pathname !== '/' && !FullScreen.filter((e) => e === pathname).length && (
          <Shell.Navigation trigger={user.menu === 'index' ? null : trigger()}>
            <PageNav />
          </Shell.Navigation>
        )} */}
        <Shell.Content>{children}</Shell.Content>
      </Shell>
    </ConfigProvider>
  );
}
